<template>
  <div></div>
</template>

<script>
  export default {
    created() {
      this.getTmsToken();
    },
    methods: {
      async getTmsToken() {
        // const { status, data } = await this.$axios.get('/order/tms/getTmsTokenByName');
        const { status, data } = await this.$axios.get(
          `/order/tms/getTmsTokenByCode?code=${this.userInfo.departmentCode}`
        );
        const allRouter = this.$store.getters.tagsViewList;
        const toRouter = allRouter[allRouter.length - 1];
        if (status == 200) {
          console.log(data);
          const getApi = (env) => {
            const apiObj = {
              development: 'http://116.63.87.240:8042/user/login',
              production: 'https://tms3.xinghy56.com/user/login',
              test: 'http://116.63.87.240:8042/user/login',
              sit: 'http://116.63.87.240:8042/user/login',
              uat: 'http://116.63.87.240:8042/user/login',
            };
            return apiObj[env];
          };
          const baseUrl = getApi(process.env.NODE_ENV);
          const url = `${baseUrl}?wcy=${data}`;
          if (data.indexOf('失败') != -1) {
            this.$message.error(data);
          } else {
            window.open(url, '_blank');
          }
        }
        this.$store.dispatch('tagsView/delView', {
          path: '/tms',
          name: 'tms',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push(toRouter.path);
      },
    },
  };
</script>

<style></style>
